export async function readWorkCenterJson(response: Response) {
  const text = await response.text();
  let data;
  try { data = text.trim() ? JSON.parse(text) : null; }
  catch { throw new Error(`De API gaf geen geldig JSON-antwoord (HTTP ${response.status}). Controleer de backendverbinding.`); }
  if (!response.ok) {
    throw new Error(typeof data?.error === "string" ? data.error : `De API-aanroep is mislukt (HTTP ${response.status}). Controleer de backendverbinding.`);
  }
  if (!data || typeof data !== "object") throw new Error("De API gaf een leeg of ongeldig antwoord. Probeer opnieuw.");
  return data;
}
